<template>
  <template v-if="comp && visibleEnPreconsulta">
    <div
        :class="[
          (editable? 'cursor-move':''),
          `xs:col-span-12 md:${comp.properties?.columns} p-2 relative group` ,
          (comp.imagenReferencia || (comp.graficas && comp.graficas.length > 0) ? 'flex items-center':''),
          (comp.typeComponent == 'SECTION'? 'border-[0.5px] border-gray-400 rounded-md':'')]" >
      <div>
        <MdiIcon v-if="comp.imagenReferencia && comp.typeComponent != 'SECTION'" class="text-blue-800 bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiImageArea" @click="openModal('imagen-'+ comp.name)" />
        <MdiIcon v-if="comp.graficas && comp.graficas.length > 0 && !editable" class="text-blue-800 bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiChartBar" @click="abrirGraficos" />
        <ModalDefault v-if="comp.imagenReferencia && comp.typeComponent != 'SECTION'" :id="'imagen-'+ comp.name" title="Imagen de referencia" size="md">
          <template #modal-body>
              <img :src="comp.imagenReferencia"/>
          </template>
        </ModalDefault>
      </div>
      <template v-if="comp.typeComponent == 'TITLE'">
        <div
          :class="`${editable ? 'border' : ''} ${comp.properties?.class} ${comp.properties?.fontSize} ${comp.properties?.fontAling} `"
          :style="`color:${comp.properties?.fontColor}; background-color:${comp.properties?.backgroundColor}`">
          {{ comp.label }}
        </div>
      </template>
      <template v-if="comp.typeComponent == 'SECTION' || comp.typeComponent == 'CONTAINER'">
        <div :id="comp.name" class="grid grid-cols-12 gap-2 p-4" :name="comp.name">
          <div v-if="comp.label" :class="['text-blue-600 col-span-12 font-bold border-b flex-row flex items-center']" >
            <MdiIcon v-if="comp.history && !editable" class="bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiHistory" @click="abrirHistorico" />
             <TooltipDefault
              :id="'TOOLTIP_' + comp.name"
              :description="comp.tooltip || 'Sin informacion adicional'"
                >
              <div class="w-auto">{{ comp.multi ? '#' + comp.item : ''}} {{ comp.label }}<span class="text-red-500">{{ comp.required ? '*':'' }}</span></div>
            </TooltipDefault>
            <MdiIcon v-if="comp.multi && agregarItem && !editable" class="bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiPlus" @click="agregarItem(comp, comp.componentId)" />
            <MdiIcon v-if="comp.multi && eliminarItem && !editable && comp.item !== 1" class="bg-red-100 rounded-md p-1 cursor-pointer border-red-200 border m-2" icono="mdiMinus" @click="eliminarItem(comp, comp.componentId)" />
            <OdontogramaModalButton v-if="comp && comp.odontograma && !editable && technologias && ciadId" :comp="comp" :odontograma="comp.odontograma" :technologias="technologias" :ciad-id="ciadId" :is-edit="isHistoriEdit ? true : false" />
            <MdiIcon v-if="comp.imagenReferencia" class="bg-blue-100 rounded-md p-1 cursor-pointer border-blue-200 border m-2" icono="mdiImageArea" @click="openModal('imagen-'+ comp.name)" />
            <ModalDefault v-if="comp.imagenReferencia" :id="'imagen-'+ comp.name" title="Imagen de referencia" size="md">
              <template #modal-body>
                  <img :src="comp.imagenReferencia"/>
              </template>
            </ModalDefault>
          </div>
          <draggable
            v-if="editable"
            v-model="(comp as IConfComponents).components"
            :group="{ name: 'componentes' }"
            class="dragArea grid grid-cols-12 col-span-12 gap-2 "
            item-key="name"
          >
            <template #item="{ element }:{ element: IFormComponent}">
              <div :class="`${element.properties?.columns} p-2 relative cursor-move group `">
                  <div class="group-hover:inline-flex absolute bg-slate-100 rounded-t-lg p-2 hidden  gap-x-2 items-center" style="right: 0px;top: -40px;">
                    <Square2StackIcon
                      class=" cursor-pointer text-sm font-semibold shrink-0 size-6 rounded-md text-blue-500 hover:bg-blue-100 disabled:opacity-50 disabled:pointer-events-none"
                      @click="copyComponent && copyComponent(element, comp.components as IFormComponent[])"
                    />
                    <Cog8ToothIcon
                      class=" cursor-pointer text-sm font-semibold shrink-0 size-6 rounded-md  text-blue-500 hover:bg-blue-100 disabled:opacity-50 disabled:pointer-events-none"
                      @click="selectComponent && selectComponent(element)"
                    />
                    <XMarkIcon
                      class=" cursor-pointer text-sm font-semibold shrink-0 size-6 rounded-md text-red-500 hover:bg-red-100 disabled:opacity-50 disabled:pointer-events-none "
                      @click="removeComponent && removeComponent(element.name)"
                    />
                  </div>
                <ComponentForm
                  :editable="editable"
                  :select-component="selectComponent"
                  :remove-component="removeComponent"
                  :copy-component="copyComponent"
                  :validacion="validacion"
                  :agregar-item="agregarItem"
                  :eliminar-item="eliminarItem"
                  :citt-id="cittId"
                  :comp="element"
                />
              </div>
            </template>
          </draggable>
          <template v-else>
              <ComponentForm
                v-for="subcom in comp.components"
                :key="subcom.name"
                :comp="subcom"
                :validacion="validacion"
                :cargar-datos-grafica-modal="cargarDatosGraficaModal"
                :cargar-datos-historico-modal="cargarDatosHistoricoModal"
                :agregar-item="agregarItem"
                :eliminar-item="eliminarItem"
                :is-read-only="isReadOnly"
                :is-pre-form="isPreForm"
                :is-histori-edit="isHistoriEdit"
                :citt-id="cittId"
              />
          </template>
        </div>
      </template>
      <div>
        <template v-if="comp.typeComponent == 'TEXT'">
        <InputDefault
          :id="comp.name"
          v-model="comp.value"
          :label="comp.label"
          :name="comp.name"
          :error="comp.required ? validacion && validacion(comp) : sinSimbolos(comp.value) ? null : 'No se permiten símbolos, emojis o caracteres especiales'"
          :placeholder="comp.placeholder"
          :compxfunciones="Array.isArray(comp.compxfunciones) ? comp.compxfunciones : []"
          :readonly="isReadOnly"
          :required="comp.required"
        />
      </template>
      <template v-if="comp.typeComponent == 'DATE'">
        <DatePickerDefault
          :id="comp.name"
          v-model="comp.value"
          :label="comp.label"
          :name="comp.name"
          :readonly="true"
          :estilo-activo-readonly="!isReadOnly"
          :clear="!isReadOnly"
          :error="comp.required ? validacion && validacion(comp) : null"
          :compxfunciones="Array.isArray(comp.compxfunciones) ? comp.compxfunciones : []"
          :required="comp.required"
          :enable-copy-paste="true"
        />
      </template>
      <template v-if="comp.typeComponent == 'CHECKBOX'">
        <SwitchDefault
          :id="comp.name"
          v-model="comp.value"
          :label="comp.label"
          :name="comp.name"
          :true-value="'SI'"
          :false-value="'NO'"
          :error="comp.required ? validacion && validacion(comp) : null"
          :compxfunciones="Array.isArray(comp.compxfunciones) ? comp.compxfunciones : []"
          :readonly="isReadOnly"
          :required="comp.required"
        />
      </template>
      <template v-if="comp.typeComponent == 'TEXTAREA'">
        <TextareaDefault
          :id="comp.name"
          v-model="comp.value"
          :label="comp.label"
          :name="comp.name"
          :error="comp.required ? validacion && validacion(comp) : sinSimbolos(comp.value) ? null : 'No se permiten símbolos, emojis o caracteres especiales'"
          :compxfunciones="Array.isArray(comp.compxfunciones) ? comp.compxfunciones : []"
          :readonly="isReadOnly"
          :required="comp.required"
        />
      </template>
      <template v-if="comp.typeComponent == 'LIST'">
        <SelectDefault
          :id="comp.name"
          v-model="comp.value"
          :label="comp.label"
          :name="comp.name"
          :options="comp.options"
          :option-text="'text'"
          :option-value="'val'"
          :clear="true"
          :error="comp.required ? validacion && validacion(comp) : null"
          :compxfunciones="Array.isArray(comp.compxfunciones) ? comp.compxfunciones : []"
          :readonly="isReadOnly"
          :required="comp.required"
        />
      </template>
      <template v-if="comp.typeComponent == 'LIST_SEARCH' && validateSelectSearch(comp.properties) && optionsMap != null">
        <SelectSearch
                :id="comp.name"
                v-model:search="comp.searchValue"
                v-model:value="comp.value"
                :label="comp.label"
                :minlength="3"
                :placeholder="comp.placeholder"
                :options="{
                  urlSearch: comp.properties?.apiService,
                  action: comp.properties?.action,
                  ruteParams: comp.properties?.ruteParams,
                  mapOptions: optionsMap,
                  params: comp.properties?.params
                }"
                :readonly="isReadOnly"
                :required="comp.required"
                :clear="true"
                :error="comp.required ? validacion && validacion(comp) : null"
              />
      </template>
      <template v-else-if="comp.typeComponent == 'LIST_SEARCH'">
        <div class="border border-red-200 p-3">
        <span class=" text-red-400 ">Debe configurar el componente para ser visualizado</span>
        </div>
      </template>
      <template v-if="comp.typeComponent == 'LISTA_SQL'">
        <ListaSql
          :comp="comp"
          :citt-id="cittId"
          :editable="editable"
        />
      </template>
      </div>
    </div>
  </template>
</template>
<script setup lang="ts">
import type { IConfComponents, IFormComponent } from '@/modules/Administracion/interfaces'
import {
  XMarkIcon,
  Cog8ToothIcon,
  Square2StackIcon
} from '@heroicons/vue/24/outline'
import { computed } from 'vue'
import draggable from 'vuedraggable'
import { aplicaEnPreconsulta, openModal, sinSimbolos } from '../../usings/generales'
import type { IComponentGraficasItems, IComponentProperties } from '@/modules/Configuracion/interfaces/IFormComponent'
import OdontogramaModalButton from '@/modules/Asistencial/components/Consultation/Odontology/OdontogramaModalButton.vue'
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces'
import ListaSql from '@/modules/Core/components/ListaSql/ListaSql.vue'

const props = defineProps<{
  comp: IFormComponent,
  editable?: boolean,
  isReadOnly?: boolean,
  removeComponent?: (component: string) => void,
  selectComponent?: (component: IFormComponent) => void,
  copyComponent?: (element: IFormComponent,components: IFormComponent[]) => void
  validacion?: (component: IFormComponent) => void
  cargarDatosHistoricoModal?: (name: string, titulo: string) => Promise<void>
  cargarDatosGraficaModal?: (value: string, graficas: IComponentGraficasItems[] , titulo: string) => Promise<void>
  agregarItem?: (item: IFormComponent, padre?: string | null) => Promise<void>
  eliminarItem?: (item: IFormComponent, padre?: string | null) => Promise<void>
  ciadId?: number
  cittId?: number
  technologias?: ICitaTechnologiasSalud[]
  isPreForm?: boolean
  isHistoriEdit?: boolean
}>()
const {
  editable = false,
  isPreForm = false,
  removeComponent,
  selectComponent,
  isReadOnly,
  copyComponent,
  agregarItem,
  eliminarItem
} = props
const comp = computed(() => props.comp)
// En preconsulta se filtran secciones y contenedores, no sus campos.
// La condición exterior evita dejar cajas vacías de secciones ocultas.
const visibleEnPreconsulta = computed(() => {
  if (!isPreForm) return true
  const tipo = comp.value?.typeComponent
  if (tipo !== 'SECTION' && tipo !== 'CONTAINER') return true
  return aplicaEnPreconsulta(comp.value as IFormComponent)
})
const optionsMap = computed(() => {
  if (comp.value.typeComponent === 'LIST_SEARCH' && validateSelectSearch(comp.value.properties)) {
    return new Function('item', comp.value.properties?.optionsMapString as string)
  }
  return null
})

const validateSelectSearch = (properties?: IComponentProperties) => {
  return properties && properties.apiService && properties.action && properties.optionsMapString && properties.optionsMapString != '' && properties.optionsMapString != 'null'
}
const abrirHistorico = () => {
  if(props.cargarDatosHistoricoModal){
    props.cargarDatosHistoricoModal(comp.value?.name as string, comp.value?.label as string)
    openModal('form-histori-component')
  }
}
const abrirGraficos = () => {
  if(props.cargarDatosGraficaModal){
    props.cargarDatosGraficaModal(comp.value?.value as string, comp.value?.graficas as IComponentGraficasItems[],  comp.value?.label as string)
    openModal('form-grafics-component')
  }
}
</script>
<style scoped>
.dragArea {
  padding: 10px;
  min-height: 100px;
  outline: 1px dashed;
}
</style>
